export function useByteUtils() {
  function bytes_to_float(bytes: Array<number> | Uint8Array): number {
    const uint8bytes = Uint8Array.from(bytes);
    const dataView = new DataView(uint8bytes.buffer);
    return Math.fround(dataView.getFloat32(0, false));
  }

  function bytes_to_uint32(bytes: Array<number> | Uint8Array): number {
    const uint8bytes = Uint8Array.from(bytes);
    const dataView = new DataView(uint8bytes.buffer);
    return dataView.getUint32(0, false);
  }

  function bytes_to_int32(bytes: Array<number> | Uint8Array): number {
    const uint8bytes = Uint8Array.from(bytes);
    const dataView = new DataView(uint8bytes.buffer);
    return dataView.getInt32(0, false);
  }

  function bytes_to_uint16(bytes: Array<number> | Uint8Array): number {
    const uint8bytes = Uint8Array.from(bytes);
    const dataView = new DataView(uint8bytes.buffer);
    return dataView.getUint16(0, false);
  }

  function bytes_to_string(bytes: Uint8Array): string {
    return new TextDecoder().decode(bytes).split("\0")[0];
  }

  //6 bytes to date_time from compressed
  function bytes_to_date_time(bytes: Array<number> | Uint8Array): Date {
    const compressedDateTime = bytes_to_uint32(bytes.slice(0, 4));
    const year = ((compressedDateTime >> 26) & 0b111111) + 2020;
    const month = (compressedDateTime >> 22) & 0b1111;
    const day = (compressedDateTime >> 17) & 0b11111;
    const hour = (compressedDateTime >> 12) & 0b11111;
    const minute = (compressedDateTime >> 6) & 0b111111;
    const second = compressedDateTime & 0b111111;
    const ms = bytes_to_uint16(bytes.slice(4, 6));
    return new Date(year, month - 1, day, hour, minute, second, ms);
  }

  function uint32_to_bytes(uint32: number): Uint8Array {
    const buffer = new ArrayBuffer(4);
    new DataView(buffer).setUint32(0, uint32);
    return new Uint8Array(buffer);
  }

  function uint16_to_bytes(uint16: number): Uint8Array {
    const buffer = new ArrayBuffer(2);
    new DataView(buffer).setUint16(0, uint16);
    return new Uint8Array(buffer);
  }

  function float_to_bytes(float: number): Uint8Array {
    const buffer = new ArrayBuffer(4);
    new DataView(buffer).setFloat32(0, Math.fround(float));
    return new Uint8Array(buffer);
  }

  /**
   * Converts a string to a byte array.
   * @param str The string to encode
   * @param buffer_size The desired size of the buffer. If null the buffer is the length of string + 0-byte
   * @returns A UInt8Array with the string encoded as ASCII.
   */
  function string_to_bytes(
    str: string,
    buffer_size: number | null = null,
  ): Uint8Array {
    const string_buffer = new Uint8Array(buffer_size ?? str.length + 1);
    new TextEncoder().encodeInto(str, string_buffer);
    return string_buffer;
  }

  function date_time_to_bytes(dt: Date): {
    dt_bytes: Uint8Array;
    ms_bytes: Uint8Array;
  } {
    const uint32_dt =
      ((dt.getFullYear() - 2020) << 26) +
      ((dt.getMonth() + 1) << 22) +
      (dt.getDate() << 17) +
      (dt.getHours() << 12) +
      (dt.getMinutes() << 6) +
      dt.getSeconds();
    const ms = dt.getMilliseconds();
    return {
      dt_bytes: uint32_to_bytes(uint32_dt),
      ms_bytes: uint16_to_bytes(ms),
    };
  }

  function int32_to_bytes(value: number): Uint8Array {
    const buffer = new ArrayBuffer(4);
    new DataView(buffer).setInt32(0, value);
    return new Uint8Array(buffer);
  }

  function two_uint16_to_uint32(first: number, second: number) {
    const bytes1 = uint16_to_bytes(first);
    const bytes2 = uint16_to_bytes(second);
    return bytes_to_uint32([bytes1[0], bytes1[1], bytes2[0], bytes2[1]]);
  }

  return {
    bytes_to_float,
    bytes_to_uint32,
    bytes_to_int32,
    bytes_to_uint16,
    bytes_to_string,
    bytes_to_date_time,
    uint32_to_bytes,
    uint16_to_bytes,
    float_to_bytes,
    string_to_bytes,
    date_time_to_bytes,
    int32_to_bytes,
    two_uint16_to_uint32,
  };
}
